import Link from 'next/link'

import Button from 'components/forms/Button'
import MediaCard from './common/MediaCard'
import { Tenant } from 'common/tenant'

type VirtualOfficePromoCardProps = {
  tenant?: Tenant
}

const VirtualOfficePromoCard = ({
  tenant = Tenant.UK,
}: VirtualOfficePromoCardProps) => {
  const au = tenant === Tenant.AU
  const virtualOfficeHref = au
    ? '/au/virtual-office-sydney'
    : '/virtual-office-london-old-street'
  return (
    <MediaCard
      imageFitPreset='cover-right'
      image={{
        alt: 'Robot arm holding mail',
        desktop: {
          dimensions: { height: 483, width: 442 },
          src: '/images/new/robot-arm-mail-desktop-v1.png',
        },
        mobile: {
          dimensions: { height: 897, width: 550 },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'media-top-content-bottom',
      }}
      imageContainerWidth={'30%'}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-8 pt-lg-18 pb-lg-7 mt-lg-0 mt-n20'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          Our <span className='color-pink2'>virtual office service </span> gives
          you AI-powered mail management, included with a prestigious business
          address. Never miss your business post.
        </h3>
        <span className='fw-semibold lh-132 fs-fluid-18-22'>
          <div>
            You get it all in one price plan when you subscribe to your new{' '}
            {au ? (
              <a href={virtualOfficeHref}>virtual office address</a>
            ) : (
              <a href='/virtual-office-london-old-street/'>
                London virtual office address
              </a>
            )}
            .
            <br />
            <br />
            <span className='fw-bold'>
              10-minute setup and no postage fees.
            </span>
          </div>
        </span>
        <Link className='align-self-lg-end' href={virtualOfficeHref}>
          <Button className='w-100 w-lg-auto'>Find out more</Button>
        </Link>
      </div>
    </MediaCard>
  )
}

export default VirtualOfficePromoCard
